export default {
  components: {
    styleOverrides: {
      root: ({ ownerState }: any) => ({
        ...(ownerState.size === 'small' && {
          width: 24,
          height: 24
        }),
        ...(ownerState.size === 'medium' && {
          width: 36,
          height: 36
        }),
        ...(ownerState.size === 'large' && {
          width: 42,
          height: 42
        })
      })
    }
  }
};
